import React, { FC, useEffect, useState } from 'react';
import { LandscapeAboutContactPersonEditTemplate } from '../../templates';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { LandscapeContactPersonResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-contact-person-response.dto';
import {
  fetchLandscapeContactPersonById,
  fetchLandscapeContactPersonByLandscapeId,
  updateLandscapeContactPerson,
} from '../../../store/landscapeAPI/landscape/reducers/landscape-contact-person.slice';
import { LandscapeContactPersonUpdateRequestDto } from '../../../store/landscapeAPI/landscape/dto/request/landscape-contact-person-update-request.dto';
import Spinner from '../../atoms/Spinner/Spinner';

interface LandscapeAboutContactPersonEditPageProps {}

const LandscapeAboutContactPersonEditPage: FC<
  LandscapeAboutContactPersonEditPageProps
> = () => {
  const { id } = useParams();
  const { contactPersonId } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [contactPerson, setContactPerson] =
    useState<LandscapeContactPersonResponseDto>();

  const { status } = useSelector(
    (state: RootState) => state.landscapeContactPersonSlice
  );

  useEffect(() => {
    if (contactPersonId) {
      dispatch(fetchLandscapeContactPersonById(contactPersonId))
        .unwrap()
        .then((response: LandscapeContactPersonResponseDto) =>
          setContactPerson(response)
        );
    }
  }, [contactPersonId, dispatch]);

  const handleOnChange = (contactPerson: LandscapeContactPersonResponseDto) => {
    setContactPerson(contactPerson);
  };

  const handleCancel = () => {
    navigate(`/landscapes/edit/${id}/about/contact-person`);
  };

  const callbackFn = async (
    contactPerson: LandscapeContactPersonResponseDto
  ) => {
    const contactPersonToUpdate: LandscapeContactPersonUpdateRequestDto = {
      name: contactPerson.name,
      role: contactPerson.role,
      emailAddress: contactPerson.emailAddress,
      compactId: contactPerson.compactId,
      entityId: contactPerson.entityId,
      entityType: contactPerson.entityType,
      id: contactPerson.id,
      published: contactPerson.published,
    };
    await dispatch(updateLandscapeContactPerson(contactPersonToUpdate));
    if (id) {
      dispatch(fetchLandscapeContactPersonByLandscapeId(id));
    }
    navigate(`/landscapes/edit/${id}/about/contact-person`);
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <>
      {contactPerson && (
        <LandscapeAboutContactPersonEditTemplate
          handleOnChange={handleOnChange}
          contactPerson={contactPerson}
          callbackFn={callbackFn}
          handleCancel={handleCancel}
        />
      )}
    </>
  );
};

export default LandscapeAboutContactPersonEditPage;
